import Api from "./Api";

class SupplierFeatureAPI extends Api{

    list(supplierId){

        let path = "/supplier/" + supplierId + "/feature";

        let endpoint =  this.combineUrl(this.apiHost,path);

        return this._get(endpoint).then(response =>  response)
        //return this._post(endpoint,{}).then(response =>  response)
    }

    save(supplierId,userId,data){
        let path = "/supplier/"  + supplierId + "/feature/" + userId;
        let endpoint =  this.combineUrl(this.apiHost,path);
        return this._post(endpoint,data)
    }

}

let _api = new SupplierFeatureAPI();

export default _api;